import request from '@/utils/request'
// 属性列表
export function fetchAreaList (params) {
  return request({
    url: '/area/getArea',
    method: 'get',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/area.js